/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {TitleOutlined} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";


const Formulario_Tours_Tarjeta_Especificacion = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


               <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre de la espeficicacion'}
                                  dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Descripcion de la espeficicacion'}
                                  dato={'descripcion'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Tours_Tarjeta_Especificacion